<template>
  <div id="app">
    <c-protocol :type="type" :data-source="dataSource"></c-protocol>
  </div>
</template>

<script>
import CProtocol from "@/components/protocol";
import util from '@/utils/util.js'
import api from '@/api'

export default {
  name: 'protocol',
  components: {
    CProtocol
  },
  data() {
    return {
      type: util.getQueryString('type') || 1,
      dataSource: {}
    }
  },
  created() {
    document.title = '协议'
    this.init()
  },
  methods: {
    init() {
      const id = util.getQueryString('id')
      if (id) { 
        this.$loading.start();
        api.getUserProtocol({ id }).then(res => {
          this.dataSource = { readonly:1, ...res.data }
        })
       }
    }
  },
}
</script>
<style lang="scss" scoped>
#app {
  // padding: 0.2rem;
  background: #ffffff;
}
</style>

